// extracted by mini-css-extract-plugin
export default {"LoginButtonsList":"SignUpSocialButtons_LoginButtonsList__J9yoB","LoginButtonItem":"SignUpSocialButtons_LoginButtonItem__33lRM"};